<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="4" class="left-tree">
        <el-card class="list-selector ">
          <ul class="list-selector-list">
            <li class="" @click="swatchDomain()"
              :class="{ 'selected': mappingManageInfo.conditions.domain === '' }">
              {{ $t('mappingManage.allConfig') }}
            </li>
            <li class="" v-for="(item, index) in mappingManageInfo.mappingDomains"
              :key="index" @click="swatchDomain(item)"
              :class="{ 'selected': mappingManageInfo.conditions.domain === item.domain }">
              {{ item.domainName }}({{ item.domain }})
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-row class="margin-bottom" v-if="mappingManageInfo.curDomain.domain">
          <el-col :span="24">
            <el-card  class="">
              <div slot="header" class="flex justify-between">
                <span>{{ mappingManageInfo.curDomain.domainName }}({{ mappingManageInfo.curDomain.domain }})</span>
              </div>
              <div class="text-left">
                {{ mappingManageInfo.curDomain.remark }}
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-row class="">
          <el-col :span="24">
            <el-card class="">
              <div slot="header" class=" flex justify-between">
                <el-form :inline="true" class="demo-form-inline">
                  <el-form-item>
                    <el-input v-model="mappingManageInfo.conditions.nameLike"
                      :placeholder="$t('mappingManage.enterName')" size="small"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="mappingManageInfo.conditions.key" :placeholder="$t('mappingManage.enterKey')"
                      size="small"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="_queryMappingMethod()" icon="el-icon-search">
                      {{ $t('mappingManage.search') }}
                    </el-button>
                  </el-form-item>
                  <el-form-item style="float:right">
                    <el-button type="primary" size="small" @click="_openAddMappingModal()" icon="el-icon-plus">
                      {{ $t('mappingManage.add') }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>

              <el-table :data="mappingManageInfo.mappings" border style="width: 100%">
                <el-table-column prop="id" :label="$t('mappingManage.codeId')" align="center"></el-table-column>
                <el-table-column prop="domain" :label="$t('mappingManage.domain')" align="center"></el-table-column>
                <el-table-column prop="name" :label="$t('mappingManage.name')" align="center"></el-table-column>
                <el-table-column prop="mappingKey" :label="$t('mappingManage.key')" align="center"></el-table-column>
                <el-table-column prop="value" :label="$t('mappingManage.value')" align="center"></el-table-column>
                <el-table-column :label="$t('mappingManage.operation')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="_openEditMappingModel(scope.row)">{{ $t('mappingManage.edit')
                      }}</el-button>
                    <el-button size="mini" type="danger" @click="_openDeleteMappingModel(scope.row)">{{
                      $t('mappingManage.delete') }}</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="footer-container">
                <div class="footer-left">
                  <div class="tip-text">
                    {{ $t('mappingManage.tip') }}
                  </div>
                </div>
                <div class="footer-right">
                  <el-pagination @current-change="handleCurrentChange" :current-page="mappingManageInfo.curPage"
                    :page-size="10" layout="total, prev, pager, next" :total="mappingManageInfo.total"></el-pagination>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <add-mapping ref="addMapping" @success="queryMapping"></add-mapping>
    <edit-mapping ref="editMapping" @success="queryMapping"></edit-mapping>
    <delete-mapping ref="deleteMapping" @success="queryMapping"></delete-mapping>
  </div>
</template>

<script>
import { listMappings, listMappingDomains } from '@/api/dev/mappingApi'
import AddMapping from '@/components/dev/addMapping/addMapping'
import EditMapping from '@/components/dev/editMapping/editMapping'
import DeleteMapping from '@/components/dev/deleteMapping/deleteMapping'

export default {
  name: 'MappingManage',
  components: {
    AddMapping,
    EditMapping,
    DeleteMapping
  },
  data() {
    return {
      mappingManageInfo: {
        mappings: [],
        mappingDomains: [],
        curDomain: {
          domainName: '',
          domain: '',
          remark: ''
        },
        name: '',
        total: 0,
        records: 1,
        curPage: 1,
        domainName: '',
        conditions: {
          domain: '',
          nameLike: '',
          key: ''
        }
      }
    }
  },
  created() {
    this._listMappings(1, 10)
    this._listMappingDomains()
  },
  methods: {
    handleCurrentChange(val) {
      this.mappingManageInfo.curPage = val
      this._listMappings(val, 10)
    },
    queryMapping() {
      this._listMappings(1, 10)
    },
    _listMappings(page, rows) {
      this.mappingManageInfo.conditions.page = page
      this.mappingManageInfo.conditions.row = rows

      listMappings(this.mappingManageInfo.conditions).then(response => {
        this.mappingManageInfo.total = response.total
        this.mappingManageInfo.records = response.records
        this.mappingManageInfo.mappings = response.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _openAddMappingModal() {
      this.$refs.addMapping.open()
    },
    _openEditMappingModel(mapping) {
      this.$refs.editMapping.open(mapping)
    },
    _openDeleteMappingModel(mapping) {
      this.$refs.deleteMapping.open(mapping)
    },
    _queryMappingMethod() {
      this._listMappings(1, 10)
    },
    _listMappingDomains() {
      listMappingDomains().then(response => {
        this.mappingManageInfo.mappingDomains = response.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    swatchDomain(item) {
      if (!item) {
        this.mappingManageInfo.conditions.domain = ''
        this.mappingManageInfo.curDomain = {}
      } else {
        this.mappingManageInfo.conditions.domain = item.domain
        this.mappingManageInfo.curDomain = item
      }
      this._listMappings(1, 10)
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 0px;
}

.left-tree {
  padding-right: 0;
}

.tree-container {
  height: 650px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.list-group {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-group-item {
  padding: 12px 15px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  text-align: center;
}

.list-group-item:hover {
  background-color: #f5f7fa;
}

.vc-node-selected {
  background-color: #ecf5ff;
  color: #409eff;
}

.footer-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tip-text {
  color: #909399;
  font-size: 12px;
}
</style>